import {
	ConfigTypeEnum,
	SchedulingModeEnum
}                             from '@app/modules/configuration/models/configuration.model';
import { IButtonGroupConfig } from '@shared/components/button-group/button-group.model';

export interface IConfigModalConfig {
	buttonGroupConfig: IButtonGroupConfig;
	configModes: { mode: ConfigTypeEnum; order: number; isRenderable: boolean; }[];
	form: {
		baseData: {};
	};
	i18n: {
		basepath: string;
		configurationModalBasePath: string;
		accountConfiguration: string;
		businessPremisesConfiguration: string;
		tssLogExpirationNotification: string;
	};
	schedulingReset: { mode: SchedulingModeEnum; isRenderable: boolean; };
	schedulingClear: { mode: SchedulingModeEnum; isRenderable: boolean; };
	translationPath: string;
	Develop?: {};
	Local?: {};
	Production?: {};
}


const configurationBasePath = 'showConfig';
const configurationModalBasePath = `modals.${ configurationBasePath }`;

export const CONFIG_MODAL_CONFIG: IConfigModalConfig = {
	translationPath: configurationBasePath,
	buttonGroupConfig: {
		items: [
			{ enforceLabelCustomTemplate: true, id: ConfigTypeEnum.GLOBAL, order: 1 },
			{ enforceLabelCustomTemplate: true, id: ConfigTypeEnum.INDIVIDUAL, order: 2 }
		]
	},
	configModes: [
		{ mode: ConfigTypeEnum.GLOBAL, order: 1, isRenderable: true },
		{ mode: ConfigTypeEnum.INDIVIDUAL, order: 2, isRenderable: true }
	],
	schedulingReset: { mode: SchedulingModeEnum.RESET, isRenderable: true },
	schedulingClear: { mode: SchedulingModeEnum.CLEAR, isRenderable: true },
	form: {
		baseData: {}
	},
	i18n: {
		basepath: configurationBasePath,
		configurationModalBasePath,
		accountConfiguration: `${ configurationModalBasePath }.accountConfiguration`,
		businessPremisesConfiguration: `${ configurationModalBasePath }.businessPremisesConfiguration`,
		tssLogExpirationNotification: `${ configurationModalBasePath }.tssLogExpirationNotification`
	},
	Develop: {},
	Local: {},
	Production: {}
};
